import _Slider from 'react-slick'
import styled from 'styled-components'

import { applyIPadOnlyStyle } from 'helpers/css'

export const Wrapper = styled.div`
    width: 65vw;
    height: 30vh;
    margin-top: 44px;
    ${applyIPadOnlyStyle(`display:none`, {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const Slider = styled(_Slider)`
    .slick-dots li {
        width: 10px;
        height: 10px;
        background: #e0e0e0;
        border-radius: 5.5px;
    }

    .slick-active button {
        width: 10px;
        height: 10px;
        border-radius: 5.5px;
        background: #95c48c;
    }

    .slick-dots button {
        width: 10px;
        height: 10px;

        ::before {
            display: none;
        }
    }

    .slick-slide {
        margin: 0 10px;
    }
`
